import { Texture } from "../../../texture";
import { Webgl2 } from "../../../webgl2";
import { Webgl2Component, Webgl2ComponentGetRenderDataOutput } from "../../webgl2-component";

type RetouchPreviewComponentState = {
  texture: Texture | null;
  u_opacity: number;
};

export class RetouchPreviewComponent extends Webgl2Component<
  undefined,
  RetouchPreviewComponentState
> {
  constructor(initialState: RetouchPreviewComponentState) {
    super(initialState);
    this.style.pointerEvents = "none";
  }

  public getRenderData(): Webgl2ComponentGetRenderDataOutput {
    if (!this.state.texture) return;
    const material = Webgl2.materials.retouchPreview;
    material.setTexture("u_texture0", this.state.texture);
    material.setUniforms({
      u_opacity: this.state.u_opacity,
    });
    return { material };
  }
}

export default RetouchPreviewComponent;
